import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import { Chevron } from "@faire/web--source/slate/icons/foundation/Chevron";
import { Column } from "@faire/web--source/slate/Layout";
import { getSpacing, Spacer } from "@faire/web--source/slate/spacing";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import { Typography } from "@faire/web--source/slate/Typography";
import { Anchor } from "@faire/web--source/ui/LinkAnchor";
import React from "react";
import styled from "styled-components";
export var JobOpeningJobsWithTier = function(param) {
    var department = param.department;
    var childDepartments = department.childDepartments;
    return childDepartments.length > 0 ? /*#__PURE__*/ _jsx(_Fragment, {
        children: childDepartments.map(function(department) {
            return /*#__PURE__*/ _jsxs(Column, {
                gap: "1x",
                children: [
                    /*#__PURE__*/ _jsx(Typography, {
                        variant: "subheadingSansMedium",
                        children: department.name
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        children: /*#__PURE__*/ _jsx(JobOpeningsJobs, {
                            department: department
                        })
                    })
                ]
            }, department.name);
        })
    }) : /*#__PURE__*/ _jsx(JobOpeningsJobs, {
        department: department
    });
};
var JobOpeningsJobs = function(param) {
    var department = param.department;
    return department.jobs.map(function(job, i) {
        return /*#__PURE__*/ _jsxs(JobLink, {
            $gray: !!((i + 1) % 2 !== 0),
            href: job.absolute_url,
            target: "_blank",
            children: [
                /*#__PURE__*/ _jsxs(ResponsiveLine, {
                    children: [
                        /*#__PURE__*/ _jsx(JobTitle, {
                            children: job.title
                        }),
                        /*#__PURE__*/ _jsx(Typography, {
                            color: Core.text.subdued,
                            children: job.location.name
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx(Spacer, {
                    width: "4x"
                }),
                /*#__PURE__*/ _jsx(StyledChevron, {
                    direction: "right"
                })
            ]
        }, job.absolute_url);
    });
};
var ResponsiveLine = styled(Column).withConfig({
    componentId: "sc-3dd24a6-0"
})([
    "flex:1;"
]);
var StyledChevron = styled(Chevron).withConfig({
    componentId: "sc-3dd24a6-1"
})([
    "transition:transform 400ms;"
]);
var JobLink = styled(Anchor).withConfig({
    componentId: "sc-3dd24a6-2"
})([
    "display:flex;align-items:center;background-color:",
    ";padding:",
    ";",
    "{padding:",
    ";}&:hover{",
    "{transform:translateX(4px);}}"
], function(param) {
    var $gray = param.$gray;
    return $gray ? Core.surface.muted : Core.surface.inverse;
}, getSpacing("2x"), responsiveMediaQueries.tabletAndAbove, getSpacing("2x", "3x"), StyledChevron);
var JobTitle = styled(Typography).attrs({
    variant: "paragraphSansMedium"
}).withConfig({
    componentId: "sc-3dd24a6-3"
})([
    ""
]);
